<template>
  <div class="bgf4">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px;">
      <div style="font-weight: 600;font-size: 25px;text-align: center;">
        山东水产标准项目申报流程
      </div>
      <div style="text-align: center;margin-top: 60px;padding-bottom: 30px;">
        <img src="../../images/flowimg.png">
      </div>
      <div v-if="islogin==true">
      <div class="search">
        <input type="text" class="searchInput" placeholder="请输入标准号或标准名称中任意关键词" v-model="name" @keyup.enter="query">
        <button @click="query" style="margin-right: 20px">搜索</button>
        <button @click="resetList">重置</button>
      </div>
      <a-table class="ta" :pagination="false"
               :customRow="customRow"
               :columns="columns" :data-source="data">
          <span slot="action" slot-scope="text, record">
            <a style="color: #1890FF;font-weight:normal;font-size:16px" @click="handleRead(record)">阅读</a>
            <a-divider type="vertical" />
            <a style="color: #1890FF;font-weight:normal;font-size:16px" @click="download(record)">下载</a>
          </span>
        <span slot="standardcode" slot-scope="text, record">
            <a class="bzha" @click="bzdetial(record.standardcode)">{{record.standardcode}}</a>
          </span>
      </a-table>
      <!--<div style="margin-top:5px;">
        <a-row :gutter="16"  >
        <a-col :span="3.5" v-for="item in data" :key="item.id" >
          <div  :bordered="false" class="card" @click="zjdetial(item.id)">
            <div class="tzlist">
              <div>
                <img v-if="item.expertimage!=null" :src="'http://localhost:8080/jeecg-boot/sys/common/static/'+item.expertimage" style="width:68px;height:96px">
                <img v-else src="../../images/expert1.png" style="width:68px;height:96px">
              </div>
              <br/>
              <p class="zjname">{{item.expertname}}</p>
              <p style="font-weight:bold">{{item.profession}}</p>
            </div>
            &lt;!&ndash;<div class="bzlist">山东水产协会</div>&ndash;&gt;
          </div>
        </a-col>
        </a-row>
      </div>-->
      <div class="fy" v-if="data.length>0">
        <span style="margin-top:4px;margin-right:5px">共&nbsp;{{total}}&nbsp;条记录</span>
        <div class="fir"><a @click="btnfir" :disabled="disabled" ref="fa">首页</a></div>
        <a-config-provider :locale="locale">
        <a-pagination  :total="ipagination.total" :item-render="itemRender" :pagination="ipagination" :defaultPageSize="ipagination.pageSize"
        v-model="ipagination.pageNo" @change='changePage'>
        </a-pagination>
        </a-config-provider>
        <div class="end"><a ref="end" :disabled="disablede" @click="endbtn">末页</a></div>
        <span style="margin-left:5px" v-if="tjcx==1">跳至&nbsp;<a-input type="text" v-model="text" @blur="change" style="width:50px;border:normal" />&nbsp;页</span>
      </div>
      </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'


export default {
  name: 'AquaticStandards',
  data(){
    return{
      data:[],
      disabled:false,
      disablede:false,
      islogin:false,
      locale: zhCN,
      ipagination:{
        current: 1,
        pageNo:1,
        pageSize: 5,
        pageSizeOptions: ['5', '15', '20'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key:'rowIndex',
          align:"center",
          width:70,
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },
        {
          title:'标准号',
          align:"left",
          dataIndex: 'standardcode',
          width:150,
          ellipsis: true,
      /*    scopedSlots: { customRender: 'standardcode' }*/
        },
        {
          title:'标准名称',
          align:"left",
          dataIndex: 'standardname',
          ellipsis: true,
          width:155
        },
        {
          title:'发布日期',
          align:"center",
          dataIndex: 'spublishdate',
          width:100
        },
        {
          title:'实施日期',
          align:"center",
          dataIndex: 'simplementdate',
          width:100,
          customRender:function (text) {
            return !text?"":(text.length>10?text.substr(0,10):text)
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          align:"center",
          fixed:"right",
          width:130,
          scopedSlots: { customRender: 'action' }
        }
      ],
      name:'',
      total:0,
      text:null,
      tjcx:1
    }
  },
  computed:{

  },
  created(){
    var arr = document.cookie.split('; ');
    if(arr.length>1) {//判断有没有下载权限
      this.islogin=true;
    }else{
      this.islogin=false;
    }
    window.addEventListener("setItem", this.printLog);
    this.query()
    if(this.ipagination.total=='0'){
      this.disablede = true
      this.disabled = true
    }
  },
  mounted () {

  },
  watch: {
    ipagination: {
        handler(newVal) {
            setTimeout(() => {
              if(newVal.pageNo=='1'){
              this.disabled = true
              this.$refs.fa.style.color = '#bfbfbf'
              }else{
                this.disabled = false
                this.$refs.fa.style.color = '#595959'
              }
            let end = newVal.total/newVal.pageSize
            end = Math.ceil(end)
            if(newVal.current!=end){
              this.disablede = false
              this.$refs.end.style.color = '#595959'
            }else{
              this.$refs.end.style.color = '#bfbfbf'
              this.disablede = true
            }
            }, 50);
        },
        deep: true
    }
  },
  methods: {
    printLog() {
      if(sessionStorage.getItem("islogin")=="1"){
       /* this.$nextTick(() => {*/
          this.islogin=true;
/*        })*/
      }else if(sessionStorage.getItem("islogin")=="2"){
       /* this.$nextTick(() => {*/
          this.islogin=false;
      /*  })*/
      }

    },
    /*zjdetial(id){
     console.log("id",id)
     window.open('/aquaticexpertsdetial?id='+id)
   },*/
    /*changeText(e){//查询
      this.name = e.target.value
    },*/
    query(){
      if(this.name==null || this.name==''){
        this.tjcx=1
      }else{
        if(this.text!=null){
          this.text=null
        }
        this.tjcx = 2
        this.ipagination.pageNo = 1
      }
      http.get('/queryStandards',{params:{pageNo:this.ipagination.pageNo,pageSize:this.ipagination.pageSize,name:this.name}}
      ).then((res) => {
        this.data = res.data.result.records
        this.ipagination.total = res.data.result.total
        this.ipagination.current = res.data.result.current
        this.total = res.data.result.total
      })
    },
    resetList(){
      this.name=null;
      this.query();
    },
    bzdetial(id){//详情
      window.open('aquaticdetial?id='+id)
    },
    handleRead(record){
      var arr = document.cookie.split('; ');
      if(arr.length>1){//判断有没有阅读权限
        http.post('/getUserQuanXian',{userid:this.$cookies.get('userid')}).then((res) => {
              if(res.data.authority !== null && res.data.authority.indexOf("9") !== -1){
               /* this.previewBzFileInfo(id, a100, a298, a302, leibie);*/
                this.previewBzFileInfo(record)
              } else {
                this.$message.warning("您没有此操作权限，请联系管理员添加！");
              }
        });
      }else{
        this.$message.warning("您尚未登录，请登录后再试！")
      }
    },
    previewBzFileInfo(record){
     var path=record.pdfurl;
     var index=path.lastIndexOf("/temp");
     path=path.substring(index+1,path.length);
  /*   window.open("http://localhost:8080/jeecg-boot/" + "temp/标准发布稿_1650337062284.pdf");*/
      let urlfile=encodeURIComponent(http.baseReadURL+path)
      window.open("static/pdfjs/web/viewer3.html?file="+urlfile);
},
    download(record){
      var arr = document.cookie.split('; ');
      if(arr.length>1){//判断有没有下载权限
        http.post('/getUserQuanXian',{userid:this.$cookies.get('userid')}).then((res) => {
          if(res.data.authority !== null && res.data.authority.indexOf("10") !== -1){
            /* this.previewBzFileInfo(id, a100, a298, a302, leibie);*/
            this.downloadBzFileInfo(record);
          } else {
            this.$message.warning("您没有此操作权限，请联系管理员添加！");
          }
        });
      }else{
        this.$message.warning("您尚未登录，请登录后再试！")
      }
    },
    downloadBzFileInfo(record){//？？？
      http.post('/downloadFileIsExists',{path: record.pdfurl}
      ).then((res) => {//先判断文件是否存在
        if(res.data=="success"){//调用正常
          window.open(http.baseURL + "/downloadFileByPath?id="+record.id+"&standardcode="+record.standardcode+"&path="+record.pdfurl,"_self");
        } else {
          this.$message.warning(res.data);
        }
      })
    },
    customRow(record, index) {
      return {
        style: {
          // // 字体颜色
          // color: record.remarkDesc ? record.remarkDesc.fontColor : '#262626',
          // 行背景色
          'background-color': index % 2 == 0 ? '#FFFFFF' : '#eff2f4',
        }
      }
    },
    change(e){//分页
      var i = parseInt(e.target.value)
      let end = this.total/this.ipagination.pageSize
      end = Math.ceil(end)
      if(i>end){
        this.ipagination.current = end
        this.ipagination.pageNo = end
        this.text = null
      }else if(i==0){
        this.ipagination.current = 1
        this.ipagination.pageNo = 1
        this.text = null
      }else if(e.target.value==null || e.target.value==''){

      }
      else{
        this.ipagination.current = i
        this.ipagination.pageNo = i
        this.text = i
      }
      this.query()

    },
    endbtn(){//分页
      if(this.text!=null){
        this.text=null
      }
      let end = this.ipagination.total/this.ipagination.pageSize
      end = Math.ceil(end)
      this.ipagination.pageNo = end
      this.query()
    },
    btnfir(){//分页
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = 1
      this.query()
    },
    changePage(e){//分页
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = e
      this.query()
    },
    itemRender(current, type, originalElement) {//分页
      if (type === 'prev') {
        return <div class="pre"><a>上一页</a></div>;
      } else if (type === 'next') {
        return <div class="next"><a>下一页</a></div>;
      }
      return originalElement;
    },
  },
}
</script>

<style scoped>
  @import "../../config/AquaticStandards.css"
</style>







// WEBPACK FOOTER //
// src/views/aquaticstandards/AquaticStandards.vue